<template>
  <div class="default-title">
     <el-form label-width="120px" ref="form" :model="form" class="list-top-margin" :size="buttonSize" :rules="rules">
        <el-row>
          <el-col :span="24">
            <el-form-item label="业务对象/属性" prop="routingNo">
              <el-cascader
              style="width: 100%;"
              v-model="form.routingNo"
              :options="options"
              clearable
              @change="handleChange"></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="text-align-center" style="position: relative;">
        <el-button size="small" @click="cancel">取 消</el-button>
        <el-button size="small" type="primary" class="title" @click="save">确 定</el-button>
      </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      buttonSize:'small',
      form:{
        routingNo:[],
      },
      rules:{
        routingNo: [{
            required: true,
            message: "请选择业务对象/属性",
            trigger: ['blur','change'],
        },] ,
      },
      options: [{
          value: '指南',
          label: '指南',
          children: [{
            value: '设计原则',
            label: '设计原则',
          }, {
            value: '导航',
            label: '导航',
          }]
      }],
    }
  },
  methods:{
    cancel(){
      this.$emit('done',{type:'cancel'})
    },
    save(){
      this.$refs.form.validate((valid) => {
          if (valid) {
            this.$emit('done',{type:'save',data:this.form})
          }
      })

    },
    handleChange(){},
  }
}
</script>
<style>
.list-top-margin .el-input-group__append, .el-input-group__prepend{
  color: #fff;
  background-color: #409EFF;
  border-radius: 0 4px 4px 0;
}
.select-count-content{
  position: absolute;
  left: 0;
  top: -45px;
  font-size: 12px;
}
</style>




// WEBPACK FOOTER //
// src/views/basicData/performAllocation/AccessDimension.vue